import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  color?: string; // Hex color
  className?: string;
}
export function Badge({
  children,
  color,
  className = ''
}: BadgeProps) {
  // If a specific hex color is provided, we use inline styles for the background with low opacity
  // and the text with high opacity
  const style = color ? {
    backgroundColor: `${color}20`,
    color: color,
    borderColor: `${color}40` // 40 = ~25% opacity
  } : undefined;
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${!color ? 'bg-slate-100 text-slate-800 border-slate-200' : ''} ${className}`} style={style} data-id="element-173">
      {children}
    </span>;
}